import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import { ordinalSuffixFormatter } from '../../../../../helper';

function PermitApplication({ permitApplication }) {
  return (
    <div className="container-fluid card-section-content">
      <div className="card-body">
        {!_.isEmpty(permitApplication) ? (
          <React.Fragment>
            <div className="row bg-white pb-3">
              <div className="col-12">
                <div className="form-wrapper mb-3 p-3">
                  {permitApplication.map(item => {
                    const terms =
                      _.get(item, 'attributes.qtr_from') ===
                        _.get(item, 'attributes.qtr_to') ||
                      _.get(item, 'attributes.qtr_from') === 0 ||
                      _.get(item, 'attributes.qtr_from') === null
                        ? ordinalSuffixFormatter(
                            _.get(item, 'attributes.qtr_to')
                          )
                        : `${ordinalSuffixFormatter(
                            _.get(item, 'attributes.qtr_from')
                          )} - ${ordinalSuffixFormatter(
                            _.get(item, 'attributes.qtr_to')
                          )}`;

                    return (
                      <div key={item.id}>
                        <table className="transaction-table table table-borderless table-sm ">
                          <tbody>
                            <tr>
                              <td className="text-dark" width="250">
                                Business Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{_.get(item, 'attributes.business_name')}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Type
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{_.get(item, 'attributes.type')}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Status
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{_.get(item, 'attributes.status')}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                OR Number
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{_.get(item, 'attributes.or_no')}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Year
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{_.get(item, 'attributes.year')}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Date
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{_.get(item, 'attributes.date_human')}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Amount
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{_.get(item, 'attributes.amount_human')}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Discount
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{_.get(item, 'attributes.disount_human')}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Penalty
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{_.get(item, 'attributes.penalty_human')}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Total
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{_.get(item, 'attributes.total_human')}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Term
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{terms}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                E-OR Number
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{_.get(item, 'attributes.e_or_no')}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                E-Permit Number
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{_.get(item, 'attributes.e_permit_no')}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                E-SOA Number
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{_.get(item, 'attributes.e_soa_no')}</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <hr />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <div className="d-flex align-items-center justitfy-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0"> No Item Found </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

PermitApplication.propTypes = {
  permitApplication: PropTypes.instanceOf(Object).isRequired,
};

export default PermitApplication;
